var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { "data-testid": "shareable-tags" } },
    [
      _c("legend", { staticClass: "col-lg-offset-1 col-lg-10" }, [
        _c("span", [
          _vm._v(_vm._s(_vm.$t("CAMPAIGN_STEP_SHAREABLE_TAGS_HEADER")))
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip.hover.right",
                value: _vm.$t("CAMPAIGN_STEP_SHAREABLE_TAGS_MESSAGE"),
                expression: "$t('CAMPAIGN_STEP_SHAREABLE_TAGS_MESSAGE')",
                modifiers: { hover: true, right: true }
              }
            ],
            staticClass: "m-l-10 f-s-16"
          },
          [_c("i", { staticClass: "fa fa-question-circle" })]
        )
      ]),
      _vm._v(" "),
      _vm.loadingTags
        ? _c(
            "div",
            { staticClass: "col-xs-12 col-lg-offset-1" },
            [_c("Loader")],
            1
          )
        : [
            _vm.availableTags
              ? _c("div", { staticClass: "form-group row m-b-5" }, [
                  _c(
                    "label",
                    { staticClass: "col-sm-3 col-md-3 control-label" },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("CAMPAIGN_STEP_SHAREABLE_TAGS_LABEL")) +
                          "\n        "
                      ),
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.hover.right",
                              value: _vm.$t(_vm.tooltipKey),
                              expression: "$t(tooltipKey)",
                              modifiers: { hover: true, right: true }
                            }
                          ]
                        },
                        [
                          _vm._v("\n            "),
                          _c("i", { staticClass: "fa fa-question-circle" })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-sm-9 col-md-9" },
                    [
                      _c("NzToggle", {
                        model: {
                          value: _vm.localOverrideShareableTags,
                          callback: function($$v) {
                            _vm.localOverrideShareableTags = $$v
                          },
                          expression: "localOverrideShareableTags"
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.localOverrideShareableTags,
                    expression: "localOverrideShareableTags"
                  }
                ],
                staticClass: "form-group row m-b-5"
              },
              [
                _c(
                  "label",
                  { staticClass: "col-sm-3 col-md-3 control-label" },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("CAMPAIGN_STEP_SHAREABLE_TAGS_SHARE_CALL_ID")
                      ) + "\n        "
                    ),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip.hover.right",
                            value: _vm.$t(
                              "CAMPAIGN_STEP_SHAREABLE_TAGS_SHARE_CALL_ID_TT"
                            ),
                            expression:
                              "\n            $t('CAMPAIGN_STEP_SHAREABLE_TAGS_SHARE_CALL_ID_TT')\n          ",
                            modifiers: { hover: true, right: true }
                          }
                        ]
                      },
                      [
                        _vm._v("\n            "),
                        _c("i", { staticClass: "fa fa-question-circle" })
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-sm-9 col-md-9" },
                  [
                    _c("NzToggle", {
                      model: {
                        value: _vm.localShareInboundCallId,
                        callback: function($$v) {
                          _vm.localShareInboundCallId = $$v
                        },
                        expression: "localShareInboundCallId"
                      }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _vm.availableTags &&
            _vm.availableTags.length &&
            _vm.localOverrideShareableTags
              ? _c("CheckBoxTagsTree", {
                  attrs: {
                    "available-tags": _vm.availableTags,
                    "selected-tags": _vm.localMacroTagstoShare,
                    "show-selected": true
                  },
                  on: {
                    "update:selectedTags": function($event) {
                      _vm.localMacroTagstoShare = $event
                    },
                    "update:selected-tags": function($event) {
                      _vm.localMacroTagstoShare = $event
                    }
                  }
                })
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }